import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { css } from 'styled-components';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo, forwardRef } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import useLegacyProps from '../../hooks/useLegacyProps.js';

var _excluded = ["children", "color", "theme", "textColor", "type"];
var _templateObject, _templateObject2;
var StyledBox = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  background-color: ", ";\n  border-left: ", ";\n  border: ", ";\n  border-radius: ", ";\n  padding: ", ";\n  position: relative;\n  text-align: left;\n  transition: box-shadow 0.3s ease-in-out, border-left 0.3s ease-in-out;\n  & + * {\n    margin-top: 1rem;\n  }\n  &:hover {\n    border-left: ", ";\n  }\n  ", "\n"])), function (_ref) {
  var inverse = _ref.inverse,
    theme = _ref.theme,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? 'black' : _ref$textColor;
  return inverse ? theme.palette.white : theme.palette[textColor];
}, function (_ref2) {
  var type = _ref2.type,
    inverse = _ref2.inverse,
    palette = _ref2.theme.palette,
    _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? 'white' : _ref2$color;
  if (inverse) {
    return palette.secondaryDarker;
  }
  return palette[color];
}, function (_ref3) {
  var type = _ref3.type,
    _ref3$theme = _ref3.theme,
    border = _ref3$theme.border,
    palette = _ref3$theme.palette;
  return type === 'list' ? "".concat(border.size.large, " ").concat(border.style, " ").concat(palette.grayLight) : null;
}, function (_ref4) {
  var type = _ref4.type,
    theme = _ref4.theme,
    _ref4$color = _ref4.color,
    color = _ref4$color === void 0 ? 'primary' : _ref4$color;
  if (type === 'color') {
    return "".concat(theme.border.size.small, " solid ").concat(theme.palette[color], "}");
  } else {
    return "".concat(theme.border.size.small, " solid ").concat(theme.palette.grayLight);
  }
}, function (_ref5) {
  var borderType = _ref5.borderType;
  return "".concat(borderType === 'rounded' ? '4px' : '0');
}, function (_ref6) {
  var size = _ref6.size;
  return size === 'large' ? '2rem' : '1rem';
}, function (_ref7) {
  var type = _ref7.type,
    _ref7$theme = _ref7.theme,
    border = _ref7$theme.border,
    palette = _ref7$theme.palette;
  return type === 'list' ? "".concat(border.size.large, " ").concat(border.style, " ").concat(palette.accent1) : null;
}, function (_ref8) {
  var type = _ref8.type;
  return type === 'header' && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n      border-bottom: none;\n      font-weight: bold;\n      font-size: ", ";\n      & + & {\n        margin-top: 0;\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n      }\n    "])), function (_ref9) {
    var theme = _ref9.theme;
    return "".concat(theme.fontSize.large);
  });
});
var Box = function Box(_ref10, ref) {
  var children = _ref10.children,
    _ref10$color = _ref10.color,
    color = _ref10$color === void 0 ? 'white' : _ref10$color,
    _ref10$theme = _ref10.theme,
    theme = _ref10$theme === void 0 ? themes["default"] : _ref10$theme,
    _ref10$textColor = _ref10.textColor,
    textColor = _ref10$textColor === void 0 ? 'black' : _ref10$textColor,
    type = _ref10.type,
    rest = _objectWithoutProperties(_ref10, _excluded);
  var _useLegacyProps = useLegacyProps(rest),
    className = _useLegacyProps.className,
    style = _useLegacyProps.style;
  /* Overrides default colors for type=color */
  if (type === 'color') {
    if (color === 'white') {
      color = 'primary';
    }
    if (textColor = 'black') {
      textColor = 'white';
    }
  }
  return /*#__PURE__*/React.createElement(StyledBox, _extends({}, rest, {
    color: color,
    theme: theme,
    className: className,
    style: style,
    textColor: textColor,
    ref: ref,
    type: type
  }), children);
};
var _Box = withDefaultTheme(/*#__PURE__*/memo(/*#__PURE__*/forwardRef(Box)));

export default _Box;
